.aibBlock {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.aibLine {
  display: inline-flex;
}

.aibLineItemHolder {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.aibLineButtons {
  right: 0;
  margin-left: 0.25rem;
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  display: flex;
  flex-direction: row;
  opacity: 0.2;
  transition: opacity 0.3s ease-in-out;
}

.aibLine:hover .aibLineButtons {
  opacity: 1;
}

.aibLine {
  width: 100%;
}

.aibReadOnly .aibLineItemHolder {
  background-color: #d3d3d329;
  color: #0d0d0dc7;
  font-style: italic;
  opacity: 1;
}

.aibLineItem {
  border-top: 1px dashed grey;
  border-left: 1px dashed grey;
}

.aibLine:last-child .aibLineItem {
  border-bottom: 1px dashed grey;
}

.aibLineItem:last-child {
  border-right: 1px dashed grey;
}

.aibLineItem.one {
  width: 100%;
}
.aibLineItem.two {
  width: 50%;
}
.aibLineItem.three {
  width: 33.3333%;
}
